import { Event } from '../interfaces';

export const isWhitelisted = (event: Event): boolean => {
  return !!event.whitelist;
};
